import React from 'react';
import { array, func } from 'prop-types';

import AccessManagementUser from './AccessManagementUser';

import s from './AccessManagement.css';


const AccessManagement = ({ ...props }) => {

  const totalUsers = props.accessUsers.length;
  const renderUserCount = (
    totalUsers === 1 ?
      `${totalUsers} person has access to your account` :
      `${totalUsers} people have access to your account`
  );

  const accessManagementUser = props.accessUsers.map((accessUser) => {
    const active = accessUser.active;
    const expiration = accessUser.expiration;
    const expired = accessUser.expired;
    const firstName = accessUser.firstName;
    const id = accessUser.id;
    const lastName = accessUser.lastName;
    const reason = accessUser.reason;
    const username = accessUser.username;

    return (
      <AccessManagementUser
        active={active}
        closeAlertDialog={props.closeAlertDialog}
        closeConfirmDialog={props.closeConfirmDialog}
        deleteUser={props.deleteUser}
        disableUser={props.disableUser}
        enableUser={props.enableUser}
        expiration={expiration}
        expired={expired}
        firstName={firstName}
        handleRefreshUsers={props.handleRefreshUsers}
        id={id}
        key={`id-${id}`}
        lastName={lastName}
        reason={reason}
        removeExpiration={props.removeExpiration}
        openConfirmDialog={props.openConfirmDialog}
        openErrorDialog={props.openErrorDialog}
        openSuccessDialog={props.openSuccessDialog}
        updateExpiration={props.updateExpiration}
        username={username}
      />
    );
  });

  return (
    <section className={s.component}>
      <h3 className={s.header}>
        Current Access
      </h3>
      <h4 className={s.subHeader}>
        {renderUserCount}
      </h4>
      {accessManagementUser}
    </section>
  );

};

AccessManagement.propTypes = {
  accessUsers: array,
  closeAlertDialog: func,
  closeConfirmDialog: func,
  deleteUser: func,
  disableUser: func,
  enableUser: func,
  handleRefreshUsers: func,
  openConfirmDialog: func,
  openErrorDialog: func,
  openSuccessDialog: func,
  removeExpiration: func,
  updateExpiration: func,
};

export default AccessManagement;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/AccessManagement/AccessManagement.js